var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-info"},[_c('i',{staticClass:"icon-info"}),_c('div',{staticClass:"info-message"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }